import { useAtom } from "@reatom/npm-react"

import { Autocomplete, Label } from "ui-kit/components-branded/index"
import { cityAtom } from "modules/PsyCatalog/common/models/filterForm"
import { citiesFetcher } from "modules/PsyCatalog/common/models/cities"

export function CitiesDropdown() {
    const [city] = useAtom(cityAtom.inputValue)
    const [cities] = useAtom(citiesFetcher.dataAtom)

    return (
        <>
            <Label htmlFor="city" className="label-with-opacity">
                Город
            </Label>
            <Autocomplete
                key={city?.id}
                items={cities}
                anyLabel="Любой"
                defaultItem={city ?? undefined}
                getValue={(item) => item.name}
                getUniqKey={(item) => item.id}
                onChange={cityAtom.onChange}
                className="is-fullwidth is-old"
            />
        </>
    )
}
